<template>
  <multiselect
    :value="value"
    @input="handleInput"
    :options="options"
    :searchable="false"
    :close-on-select="closeOnSelect"
    :show-labels="false"
    :placeholder="placeholder"
    :hideSelected="hideSelected"
    class="multiselect-rounded multiselect-blue"
    v-bind="$attrs"
  >
    <template slot="selection" slot-scope="{ values, isOpen }">
      <span
        class="multiselect__single"
        v-if="values.length &amp;&amp; !isOpen"
      >{{ values.length }} options selected</span>
    </template>
  </multiselect>
</template>
<script>
import Multiselect from 'vue-multiselect'
import '../../../styles/components/custom-select.css'

export default {
  name: 'selectRounded',

  components: {
    Multiselect,
  },
  props: {
    value: {
      type: [String, Object]
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    closeOnSelect: {
      type: Boolean,
      default: true,
    },
    hideSelected: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleInput(value) {
      this.value = value
      this.$emit('input', value)
    }
  }
}
</script>